// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__pQVhc","approved":"Status_approved__2AUao","rejected":"Status_rejected__3Ui3a","expired":"Status_expired__BS8Fh","label":"Status_label__EyvRM"};